import { queryOptions } from "@tanstack/react-query";
import { getOfficers } from "@/features/users/api/officersApi";
import { fetchUsers } from "../../../shared/utils/fetchUsers";
import type { ListUsersResponse } from "../../../shared/interfaces/ListUsersResponse";
import type { ReportGenUser } from "../../../shared/interfaces/User";

export const usersKeys = {
  all: ["users"] as const,
  station: (stationId: string) => [...usersKeys.all, "station", stationId] as const,
  stationList: (stationId: string, opts: { includeInactive: boolean }) =>
    [...usersKeys.station(stationId), opts] as const,
};

/**
 * Active-officer directory used for synchronous name resolution
 * (userDirectory.getUserName). Mirrors the old getOfficers call — no
 * includeInactive param.
 */
export function stationDirectoryQuery(stationId: string) {
  return queryOptions<ListUsersResponse>({
    queryKey: usersKeys.stationList(stationId, { includeInactive: false }),
    queryFn: () => getOfficers(stationId),
    staleTime: 5 * 60_000,
    // Long retention: comments render names long after the fetch; an active
    // useUserDirectory observer keeps it alive while any consumer is mounted.
    gcTime: 30 * 60_000,
  });
}

/** Full station roster (incl. inactive) for the ManageUsers panel. */
export function stationUsersQuery(stationId: string) {
  return queryOptions<ReportGenUser[]>({
    queryKey: usersKeys.stationList(stationId, { includeInactive: true }),
    queryFn: () => fetchUsers(stationId, true),
    staleTime: 5 * 60_000,
    gcTime: 30 * 60_000,
  });
}
